import Vue from 'vue'
import Vuex from 'vuex'

// Core store
import state from './core/state'
import getters from './core/getters'
import mutations from './core/mutations'
import actions from './core/actions'


// Required Modules
// Should not import any non require modules here to reduce bundle size and first byte loading time.
import Theme from '@/store/modules/theme'
import Accounting from '@/store/modules/accounting'
import Master from '@/store/modules/master'
import User from '@/store/modules/user'

Vue.use(Vuex)

// Set Strict mode
const strict = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict,
  // Core
  state,
  getters,
  mutations,
  actions,
  // Modules
  modules: {
    Theme,
    Accounting,
    Master,
    User
  }
})
